// extracted by mini-css-extract-plugin
export default {"main":"gallery_main__lVU94","galleries":"gallery_galleries__3+fYi","imagesBox":"gallery_imagesBox__QdRHx"};